import { useEffect, useContext } from 'react';
import { useNavigate, useLocation, matchPath } from 'react-router-dom';

import { UIContext } from '../../contexts/UIContext';

import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import MapIcon from '@mui/icons-material/Map';
import CampaignIcon from '@mui/icons-material/Campaign';
import ImageSearchIcon from '@mui/icons-material/ImageSearch';
import PolylineIcon from '@mui/icons-material/Polyline';

import './BottomMenu.scss';

function BottomMenu() {
  const {
    selectedBottomMenuOption,
    setSelectedBottomMenuOption
  } = useContext(UIContext);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPageNotInMenu =
    matchPath('/profile', location.pathname) ||
    matchPath('/about', location.pathname);
  const selectedMenuOption = !currentPageNotInMenu ? selectedBottomMenuOption || 0 : 0;

  function handleChange(_, newValue) {
    setSelectedBottomMenuOption(newValue);

    switch (newValue) {
      case 0: navigate('/home'); break;
      case 1: navigate('/denounces'); break;
      case 2: navigate('/working-areas'); break;
      case 3: navigate('/vector-foci'); break;
      default: navigate('/home');
    }
  }

  return (
    <Box sx={{ width: 500 }} className="bottom-menu">
      <div className="cool-border-top"></div>
      <BottomNavigation
        showLabels
        value={selectedMenuOption}
        onChange={handleChange}
      >
        <BottomNavigationAction label="Dashboard" icon={<MapIcon />} />
        <BottomNavigationAction label="Denúncias" icon={<CampaignIcon />} />
        <BottomNavigationAction label="Áreas" icon={<PolylineIcon />} />
        <BottomNavigationAction label="Focos" icon={<ImageSearchIcon />} />
      </BottomNavigation>
    </Box>
  );
}

export default BottomMenu;
